import { UIView } from '@uirouter/react';
import { UiRouter } from './UiRouter';
import { AuthenticatedLayout } from './AuthenticatedLayout';
import { useSessionState } from 'ui/state/hooks';

export const App: React.FC = () => {
  const { loggedInUser } = useSessionState();

  return (
    <UiRouter>
      {Boolean(loggedInUser) ? (
        <AuthenticatedLayout>
          <UIView />
        </AuthenticatedLayout>
      ) : (
        <UIView />
      )}
    </UiRouter>
  );
};
